import React from 'react';
import { Modal, Row, Col, Button, Badge } from 'react-bootstrap';
import moment from 'moment';
import 'moment/locale/es';

const formatoCOP = (n) => `$${Number(n || 0).toLocaleString('es-CO')}`;

const ModalNotificacionTransaccion = ({
  transaccion,
  procesando,
  onRecibir,
  onRechazar,
  onCerrar
}) => {
  if (!transaccion) return null;

  const esEntrega = transaccion.tipo === 'ENTREGA';
  const titulo = esEntrega ? 'Entrega de dinero pendiente' : 'Traslado de dinero pendiente';
  const emisorNombre = transaccion.emisor
    ? `${transaccion.emisor.nombre || ''} ${transaccion.emisor.apellido || ''}`.trim() || transaccion.emisor.email || '—'
    : '—';
  const bolsilloNombre = transaccion.bolsilloDestino && transaccion.bolsilloDestino.nombre
    ? transaccion.bolsilloDestino.nombre
    : '—';

  return (
    <Modal show onHide={onCerrar} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>{titulo}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="g-2 mb-3">
          <Col xs={6}><strong>Tipo:</strong></Col>
          <Col xs={6} className="text-end">
            <Badge bg={esEntrega ? 'primary' : 'info'}>
              {esEntrega ? 'Entrega' : 'Traslado'}
            </Badge>
          </Col>

          {transaccion.consecutivo && (
            <>
              <Col xs={6}><strong>Consecutivo:</strong></Col>
              <Col xs={6} className="text-end">{transaccion.consecutivo}</Col>
            </>
          )}

          <Col xs={6}><strong>De:</strong></Col>
          <Col xs={6} className="text-end">{emisorNombre}</Col>

          <Col xs={6}><strong>Monto:</strong></Col>
          <Col xs={6} className="text-end fw-bold">{formatoCOP(transaccion.monto)}</Col>

          <Col xs={6}><strong>Bolsillo destino:</strong></Col>
          <Col xs={6} className="text-end">{bolsilloNombre}</Col>

          {transaccion.concepto && (
            <>
              <Col xs={6}><strong>Concepto:</strong></Col>
              <Col xs={6} className="text-end">{transaccion.concepto}</Col>
            </>
          )}

          <Col xs={6}><strong>Fecha:</strong></Col>
          <Col xs={6} className="text-end">
            {moment(transaccion.fecha).locale('es').format('LLL')}
          </Col>
        </Row>

        <div className="border rounded p-2 mb-2 bg-light">
          <Row className="g-1">
            <Col xs={8}>Saldo actual de tu bolsillo:</Col>
            <Col xs={4} className="text-end">{formatoCOP(transaccion.saldoActualReceptor)}</Col>
            <Col xs={8}><strong>Saldo si recibes:</strong></Col>
            <Col xs={4} className="text-end fw-bold text-success">
              {formatoCOP(transaccion.saldoNuevoSiRecibe)}
            </Col>
          </Row>
        </div>

        <p className="text-muted small mb-0">
          Pulsa <strong>Recibir</strong> para confirmar, <strong>Rechazar</strong> si no corresponde,
          o <strong>Cerrar</strong> para decidir más tarde (la transacción seguirá pendiente).
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onCerrar} disabled={procesando}>
          Cerrar
        </Button>
        <Button variant="danger" onClick={onRechazar} disabled={procesando}>
          Rechazar
        </Button>
        <Button variant="primary" onClick={onRecibir} disabled={procesando}>
          Recibir
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalNotificacionTransaccion;
